var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_info",
    opacity: 0.505
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_598",
    "data-name": "Ellipse 598",
    fill: "none",
    stroke: "#a3a3a3",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6521",
    "data-name": "Path 6521",
    d: "M.153-2.411A1.3,1.3,0,0,1-.74-2.723a1.13,1.13,0,0,1-.351-.893V-6.235A1.1,1.1,0,0,1-.74-7.118a1.324,1.324,0,0,1,.893-.3,1.363,1.363,0,0,1,.9.3,1.084,1.084,0,0,1,.361.883v2.619a1.114,1.114,0,0,1-.361.893A1.335,1.335,0,0,1,.153-2.411Zm0-6.924A1.533,1.533,0,0,1-.931-9.707a1.264,1.264,0,0,1-.4-.973,1.233,1.233,0,0,1,.4-.963A1.56,1.56,0,0,1,.153-12a1.568,1.568,0,0,1,1.074.361,1.218,1.218,0,0,1,.411.963,1.264,1.264,0,0,1-.4.973A1.533,1.533,0,0,1,.153-9.335Z",
    transform: "translate(9.847 16.708)",
    fill: "#a3a3a3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.60551fed.svg";
export { ForwardRef as ReactComponent };